module.exports = __webpack_public_path__ + "img/img_8.4cbe43a2.jpeg";